var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{class:_vm.bem()},[_c('div',{class:_vm.bem('container')},[_c('router-link',{class:_vm.bem('logo'),attrs:{"to":"/"},nativeOn:{"click":function($event){return _vm.closeNav.apply(null, arguments)}}},[_c('span',{class:_vm.bem('logo-title')},[_vm._v("智能互联生态联盟")])]),_c('app-nav',{ref:"nav",class:_vm.bem('nav')})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }